import React, {useEffect, useState} from "react";
import {
    classNames,
    getDefaultTableOptions,
    getDefaultTableOptionsJSON,
    getProp,
    saveTableColumns,
    updateQuery
} from "../../../../util/util-helpers";
import TableSettingsPopOver from "../../../resource-table/table-components/table-settings-popover";
import ActiveFilters from "../../../resource-table/table-components/active-filters";
import TableCard from "../../../resource-table/table-components/table-card";
import ResourceTableTopBar from "../../../resource-table/table-components/resource-table-top-bar";
import TableFilters from "../../../resource-table/table-components/table-filters";
import ResourceTable from "../../../resource-table";
import NoRecords from "../../../no-records-found/no-records";
import Pagination from "../../../resource-table/table-components/pagination";
import TableCardFooter from "../../../resource-table/table-components/table-card-footer";
import TableOptionsDialog from "../../../resource-table/table-components/table-options-dialog";
import {FieldsManager} from "../../../../../data/services/fields";
import {cloneDeep} from "../../../../util/util-vanilla";
import Resources from "../../../../../data/services/resources";
import Tooltip from "../../../tooltip";
import {ViewfinderCircleIcon} from "@heroicons/react/24/outline";
import LocalStorage from "../../../../util/localStorage";
import {TABLE_OPTIONS_SUF} from "../../../../../util/util-constants";
import PopoverDatePicker from "../../../popover/popover-datepicker";
import PayDateFilter from "../../../../../views/accounting/carrier-pay/carrier-pay-date-filter";
import {excludeFields} from "../../../../util/util-fields";


export default function ResourceList({
                                         fields,
                                         resource,
                                         translate,

                                         fetchData,
                                         isLoading,
                                         isLoadingSilent,
                                         queryFields,
                                         setQueryFields,
                                         query,
                                         dispatch,
                                         listPath,

                                         onMount,
                                         selects,
                                         onRowClick,
                                         onView,
                                         onEdit,
                                         onDelete,
                                         onRestore,
                                         actions,
                                         hasViewPerm,
                                         hasEditPerm,
                                         hasDeletePerm,
                                         hasRestorePerm,
                                         onRefreshTable,
                                         dataImages,
                                         maxHeightClass,
                                         afterFiltersHtml,
                                         beforeSettingsHtml,
                                         toggleAutoRefresh,
                                         updatedRows,
                                         isAutoRefreshEnabled,
                                         allFiltersClass = "hidden",
                                         excludeActiveFilters,
                                         excludeDateFields,
                                         tableTitle,
                                         tableDefaults = {
                                             behaviour: {
                                                 rowSelect: true,
                                                 hasMenu: true,
                                                 canAdjustWidth: true
                                             },
                                             // columns: {
                                             //     RentalStatusID: {
                                             //         minWidth: 200
                                             //     }
                                             // },
                                             style: {
                                                 condensed: true,
                                                 isGPUAccelerated: true
                                             }
                                         },
                                         onSelectRow,
                                         selectedRows,
                                         tableKey,
                                         children,
                                         onSelectAllClick,
                                         Data,
                                         Count,
                                         tableCardClass,
                                         onToggleRowFocusClick,
                                         focusLastVisitedRow,
                                         tableID,
                                         handleColumnFilterInputChange,
                                         onClearAllFiltersClick,
                                         oldTableStorageKey,
                                         datePicker,
                                         dateRangePicker
                                     }) {

    /** Constants
     ================================================================= */
    const data = Data ?? dataImages ?? getProp(resource, "data.list", []);
    const count = Count ?? dataImages?.length ?? getProp(resource, "data.count", 0)
    const [isColumnsDialogVisible, setIsColumnsDialogVisible] = useState(false)

    const handleQueryChange = (name, value) => {
        let queryUpdate = updateQuery(queryFields, {}, name, value);

        if (name === 'query') {
            queryUpdate.offset.value = 0;
        }

        if (name === 'limit') {
            queryUpdate.offset.value = "0"
        }

        if (name === 'archived') {
            queryUpdate.offset.value = 0;
        }

        if (name === 'StatusID') {
            queryUpdate.offset.value = 0;
        }
        if (name === 'TrailerOwnershipTypeID') {
            queryUpdate.offset.value = 0;
        }
        if (name === 'NotSoldRetired') {
            queryUpdate.offset.value = 0;
        }

        if (name === "RentContactID") {
            queryUpdate.RentOrganizationID.value = null;
        }

        if (name === "RentOrganizationID") {
            queryUpdate.RentContactID.value = null;
        }

        if (name === "PayContactID") {
            queryUpdate.PayOrganizationID.value = null;
        }

        if (name === "PayOrganizationID") {
            queryUpdate.PayContactID.value = null;
        }

        if (listPath === (Resources.WorkOrders + "_list")) {
            if (name === "ShowOnlyCompleted") {
                queryUpdate.ShowOnlyActive.value = 0
            }

            if (name === "ShowOnlyActive") {
                queryUpdate.ShowOnlyCompleted.value = 0
            }
        }

        setQueryFields(queryUpdate);

        if (fetchData) {
            fetchData(dispatch, FieldsManager.getFieldKeyValues(queryUpdate));
        }
    }

    /** Data events
     ================================================================= */
    function handleFilterInputChange(name, value) {
        setQueryFields(Object.assign({}, FieldsManager.updateField(queryFields, name, value)), undefined, name, value);
    }

    function handleClearFiltersClick(excludeAdditional = []) {
        const queryFieldsCLone = Object.assign({}, queryFields);
        const excludedFields = ['limit', 'offset', 'sort', 'sortBy'];

        Object.values(queryFields).filter(it => !excludedFields.includes(it.name)).forEach(it => {
            FieldsManager.updateField(queryFieldsCLone, it.name, '')
        });

        if (onClearAllFiltersClick) {
            onClearAllFiltersClick();
        } else {
            setQueryFields(queryFieldsCLone);
        }
    }

    /** UI events
     ================================================================= */
    let checkboxFilters = Object.values(queryFields).reduce((memo, it) => {
        if (it.type === 'checkbox') {
            memo.push(it.name);
        }
        return memo;
    }, []);

    let otherFilters = Object.values(queryFields).reduce((memo, it) => {
        if (it.type !== 'checkbox' && it.name !== 'limit' && it.name !== 'query') {
            memo.push(it.name);
        }
        return memo;
    }, []);

    const [tableOptions, setTableOptions] = useState(
        () => getTableOptions()
    );

    function getTableOptions() {
        let options = getDefaultTableOptions(fields, tableDefaults, listPath, translate);

        if (oldTableStorageKey && LocalStorage.has(oldTableStorageKey)) {
            options = getDefaultTableOptions(fields, tableDefaults, oldTableStorageKey, translate);
            const storageOptions = LocalStorage.get(oldTableStorageKey + TABLE_OPTIONS_SUF);
            LocalStorage.set(listPath + TABLE_OPTIONS_SUF, storageOptions);
            LocalStorage.remove(oldTableStorageKey);
        }

        if (tableDefaults?.style?.columnFilters !== undefined && options?.style?.columnFilters === undefined) {
            options.style.columnFilters = false;
        }

        return options;
    }

    const handleSetTableOptions = (options) => {
        setTableOptions(options);
        if (listPath) {
            saveTableColumns(listPath, options);
        }
    }

    const setTableColumnOptions = (columns) => {
        let tableOptionsUpdate = cloneDeep(tableOptions)

        tableOptionsUpdate.columns = columns.reduce((memo, it) => {
            memo[it.name] = it
            return memo
        }, {})

        setTableOptions(tableOptionsUpdate)
        setIsColumnsDialogVisible(false)
        saveTableColumns(listPath, tableOptionsUpdate)
    }

    const getDefaultTableColumnOptions = () => {
        return getDefaultTableOptionsJSON(fields, {}, translate)
    }
    /** Lifecycle
     ================================================================= */
    useEffect(() => {
        if (typeof onMount === "function") {
            onMount(dispatch, query);
        }
    }, [])

    /** Component Body
     ================================================================= */
    return (
        <React.Fragment>
            <div className="flex items-center py-1">
                <div className={'shrink-0 text-lg mx-2'}>
                    {tableTitle}
                </div>

                <ActiveFilters
                    excludedFields={excludeActiveFilters}
                    onLabelClick={handleFilterInputChange}
                    onClearFiltersClick={handleClearFiltersClick}
                    filterFields={queryFields}
                    handleQueryChange={handleQueryChange}
                    translate={translate}
                />

                {beforeSettingsHtml}

                <div className="ml-auto flex items-center">
                    <TableSettingsPopOver
                        options={tableOptions}
                        setOptions={handleSetTableOptions}
                        toggleColumnSettingsDialog={() => setIsColumnsDialogVisible(true)}
                        translate={translate}
                    />

                    {afterFiltersHtml}
                </div>
            </div>

            <TableCard tableCardClass={tableCardClass}>
                <ResourceTableTopBar addClass={'inline-block w-full'}>
                    <TableFilters
                        hideLimit
                        selects={selects}
                        addClass={"items-center items-center text-tm-gray-900 w-full"}
                        className={"flex gap-2"}
                        filterFields={excludeDateFields ? excludeFields(queryFields, excludeDateFields) : queryFields}
                        handleInputChange={handleQueryChange}
                        translate={translate}
                        toggleAutoRefresh={toggleAutoRefresh}
                        onRefreshTable={onRefreshTable}
                        isLoading={isLoading || isLoadingSilent}
                        isAutoRefreshEnabled={isAutoRefreshEnabled}
                        customHtml={datePicker ?
                            <PopoverDatePicker
                                queryFields={queryFields}
                                onQueryInputChange={handleQueryChange}
                                updateFields={setQueryFields}
                                translate={translate}
                            /> : dateRangePicker ?
                                <PayDateFilter
                                    queryFields={queryFields}
                                    translate={translate}
                                    updateQueryFields={(queryFieldsUpdate) => {
                                        setQueryFields(queryFieldsUpdate)
                                    }}
                                    onQueryChange={handleQueryChange}
                                /> : null
                        }
                    >
                        {onToggleRowFocusClick && focusLastVisitedRow !== undefined && (
                            <Tooltip content="Toggle focus to the last visited row">
                                <button
                                    onClick={onToggleRowFocusClick}
                                    className={
                                        classNames("btn btn-header", focusLastVisitedRow ? "text-primary" : "")
                                    }
                                >
                                    {focusLastVisitedRow && (
                                        <ViewfinderCircleIcon className="size-5"/>
                                    )}

                                    {!focusLastVisitedRow && (
                                        <ViewfinderCircleIcon className="size-5"/>
                                    )}
                                </button>
                            </Tooltip>
                        )}

                        {!!datePicker && (
                            <div className={"absolute translate-x-0 left-66"}>
                                <PopoverDatePicker
                                    queryFields={queryFields}
                                    onQueryInputChange={handleQueryChange}
                                    updateFields={setQueryFields}
                                    translate={translate}
                                />
                            </div>
                        )}
                    </TableFilters>
                </ResourceTableTopBar>

                <ResourceTable
                    addTableClass="z-0 border-x border-tm-gray-300"
                    data={data}
                    updatedRows={updatedRows}
                    fields={fields}
                    maxHeightClass={maxHeightClass}
                    queryFields={queryFields}
                    focusOnLastVisitedRow={focusLastVisitedRow}
                    translate={translate}
                    isLoading={isLoading}
                    options={tableOptions}
                    onSelectAllClick={onSelectAllClick}
                    onSelectRow={onSelectRow}
                    onSortChange={(fieldName) => handleQueryChange("sortBy", fieldName)}
                    saveTableOptions={handleSetTableOptions}
                    onRowClick={onRowClick}
                    selectedRows={selectedRows}
                    onView={onView}
                    onEdit={onEdit}
                    onDelete={onDelete}
                    onRestore={onRestore}
                    actions={actions}
                    hasViewPerm={hasViewPerm}
                    hasEditPerm={hasEditPerm}
                    hasDeletePerm={hasDeletePerm}
                    hasRestorePerm={hasRestorePerm}
                    handleColumnFilterInputChange={handleColumnFilterInputChange}
                    filterSelects={selects}
                    tableID={tableID}
                    tableKey={tableKey}
                />

                {children}

                <NoRecords
                    show={!isLoading && !count}
                    addClass="p-10"
                    title={translate("No matching records found")}
                />

                <TableCardFooter
                    show={!(!data.length && !isLoading)}
                >
                    <Pagination
                        count={count}
                        isLoading={isLoading}
                        handleQueryChange={handleQueryChange}
                        queryFields={queryFields}
                        translate={translate}
                    />
                </TableCardFooter>
            </TableCard>

            <TableOptionsDialog
                show={isColumnsDialogVisible}
                pagePath={listPath}
                columns={tableOptions.columns}
                setTableColumnOptions={setTableColumnOptions}
                getDefaultTableColumnOptions={getDefaultTableColumnOptions}
                onClose={() => setIsColumnsDialogVisible(false)}
                translate={translate}
            />
        </React.Fragment>
    )
}

